export default __webpack_public_path__ + "static/media/daryl.40eef921.png";